// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"checkbox_checkboxWrapper__o5EwX","checkbox":"checkbox_checkbox__L2Bt-"};